import React from "react";
import { VendorCameras } from "./cameras.jsx";

export function LiveView() {
  const sale = window.VD.cameraPlayback?.enabled ? window.VD.cameraPlayback.sale : null;
  return sale ? <VendorCameras key={sale} sale={sale}/> : <p role="status">Select a sale to view cameras.</p>;
}
